/* eslint-disable */
// 目前兼容 I2SelectV4 I2HeaderSearch(没有放大镜) I2DatePicker
// 如果 存在 重置方法， 父级组件 *** refQ: true *** (!!! 必须存在) 否则可能导致 仔组件可能无法重置状态
// 
import React, { Fragment, useState, useEffect } from 'react'
import { Card, Button, Row, Col } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { omit } from 'lodash'
import * as R from 'ramda'

const colSpanConfig = {
  'b1': {
    left: { sm: 19, md:20, lg:21, xl: 22 },
    right: { sm: 5, md:4, lg:3, xl: 2 }
  },
  'b2': {
    left: { sm: 17, md: 18, lg: 19, xl: 20 },
    right: { sm: 7, md: 6, lg:5, xl: 4 }
  },
}

const HeaderControl = (props) => {
  const {
    children, colSpan, searchText, // 组件 功能参数
    query, refQuery, // 组件 数据源
    path, requestType, fetching, // 请求相关控制数据
    action, actionChange // 请求方法
  } = props
  // 初始化Query
  const [headerQuery, setHeaderQuery] = useState(query)

  // console.log('headerQuery', headerQuery)
  useEffect(() => {
    // 监听是否发生请求动作，整合请求参数
    const mergeData = R.mergeRight(headerQuery, query)
    // console.log('mergeData', mergeData)
    return setHeaderQuery(mergeData)
  }, [fetching])

  // 监听键盘时间
  useEffect(() => {
    window.addEventListener('keydown', onKeyDown) // 添加全局事件
    return () => {
      window.removeEventListener('keydown', onKeyDown) // 销毁
    }
  })
  // 键盘事件
  const onKeyDown = (e) => {
    switch (e.keyCode) {
      case 13: // 回车键
        handleUpdate('action')
        break
    }
  }

  // 控制组件传入字段
  const handleChange = (objQuery, clearKey) => {  
    // console.log('handleChange', objQuery, 'clearKey', clearKey)
    let formatQuery = R.mergeRight(headerQuery, objQuery)
    // --- 清理数据 ---
    if (clearKey) {
      formatQuery = omit(formatQuery, clearKey)
    }
    setHeaderQuery(formatQuery)
  }

  // 提交获取申请
  const handleUpdate = (getType) => {
    const actionQuery = getType === 'ref'
      ? refQuery
      : headerQuery
    // console.log('actionQuery', actionQuery)
    setHeaderQuery(actionQuery)

    if (actionChange) {
      actionChange(actionQuery)
    }
    if (action) {
      switch (requestType) {
        case 'path': {
          return action(path, actionQuery)
        }
        default: {
          return action(actionQuery)
        }
      }
    }
  }

  const renderChildren = React.Children.map(children, (child) => {
    if (!React.isValidElement(child)) {
      return child
    }
    if (child.props) {
      child = React.cloneElement(child, {
        headerChange: handleChange,
        headerchange: handleChange,
        query: headerQuery
      })
    }
    return child
  }, [children])
  const contorlMode = (
    <div style={{ textAlign: 'right' }}>
      {
        refQuery && <Button
          style={{ marginRight: 8 }}
          onClick={handleUpdate.bind(this, 'ref')}
        >
          重置
        </Button>
      }
      <Button
        type='primary'
        onClick={handleUpdate.bind(this, 'action')}
        icon={<SearchOutlined />}
      >
        {searchText || '搜索'}
      </Button>
    </div>
  )
  return (
    <Row gutter={[8, 8]} align='middle'>
      <Col
      { ...colSpanConfig[colSpan || 'b2'].left }
      >
        {renderChildren}
      </Col>
      <Col
      { ...colSpanConfig[colSpan || 'b2'].right }
      >
        {contorlMode}
      </Col>
    </Row>
  )
}
export default HeaderControl
